import { ChangeEvent, useState, KeyboardEvent } from 'react';

import TextInput from '../../../../TextInput';
import newUseFilterParams from '../../../../../hooks/newUseFilterParams';

export function SimpleSearchField({ placeholder }: { placeholder?: string }) {
  const { params, changeFilter } = newUseFilterParams({
    filters: {
      searchOrgGroup: '',
    },
  });

  const [searchState, setSearchState] = useState<string>(
    params?.searchOrgGroup ?? '',
  );

  const handleFieldChange = ({
    target: { value },
  }: ChangeEvent<HTMLInputElement>) => {
    setSearchState(value);
  };

  const handleApplySearch = () => {
    if (searchState.length > 4 || searchState.length === 0) {
      changeFilter(
        'searchOrgGroup',
        searchState.length === 0 ? '' : searchState,
      );
    }
  };

  const handleEnter = ({ key }: KeyboardEvent) => {
    if (key === 'Enter') {
      (document.activeElement as HTMLElement)?.blur();
    }
  };

  return (
    <TextInput
      onChange={handleFieldChange}
      onBlur={handleApplySearch}
      placeholder={placeholder}
      onKeyDown={handleEnter}
      iconStart="actions-b2b-search"
      value={searchState}
      name="search"
      fullWidth
    />
  );
}
